// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-input.expanding-search{transition:max-width .4s}.v-input.expanding-search .v-input__slot:after,.v-input.expanding-search .v-input__slot:before{border-color:transparent!important}.v-input.expanding-search.closed{max-width:40px!important}.v-input.expanding-search.closed .v-input__slot{background:transparent!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
